import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'clsx';
import { FormFooterContainer } from './styles/form-footer.styled';
const FormFooter = ({ children, className, class: reactClassName, dataTest = 'form-footer', }) => {
    const formFooterClassNames = classNames(className || reactClassName, 'PONCHO-form__footer');
    return (_jsx(FormFooterContainer, { className: formFooterClassNames, "data-test": dataTest, children: children }));
};
export default FormFooter;
